export default __webpack_public_path__ + "static/media/twitter.c3ce3a3a.svg";